export const API_CONFIG = {
  get baseUrl() {
    return `${process.env.BACKEND_API}/api`
  },
  endpoints: {
    auth: {
      generatePayload: '/auth/generate-payload',
      checkProof: '/auth/check-proof',
    },

    boxes: {
      getAll: '/boxes',
      getById: (id: string | number) => `/boxes/${id}`,
    },

    boxCollections: {
      getActive: '/box-collections/active',
    },

    users: {
      activityVotes: '/users/activity/votes',
      activityCreatedBoxes: '/users/activity/created-boxes',
      transactionSent: '/users/transaction-sent',
      profile: '/users/profile',

      bonus: {
        stats: '/users/bonuses/stats',
        tasks: '/users/bonuses/tasks',
        referrals: '/users/bonuses/referrals',
        claim: '/users/bonuses/claim',
      },
    },

    faq: {
      getAll: '/faq',
    },

    storage: {
      upload: '/storage/upload',
    },
  },
} as const
